import React, { useState, useEffect } from "react";
import UserPanel from "@/Components/PageTop/UserPanel";
import HomeLogo from "@/assets/loginLogo.svg";
import { rebuildFormula } from "@/config/func";
import { useNavigate } from "react-router-dom";
import { calc_mixture_properties, getMaterials } from "@/services/propsApi";
import { Button, Card, Checkbox, Col, Divider, Form, Input, Row, Space, Spin } from "antd";
import { K0 } from "@/config/const";
// import { get_properties_from_cas } from "@/services/propsApi";

const rmap:any={
  gas: [
    { name: "V", nameCn: "气相混合物摩尔体积", unit: "m³/mol" },
    { name: "H", nameCn: "气相混合物摩尔焓", unit: "J/mol" },
    { name: "S", nameCn: "气相混合物摩尔熵", unit: "J/mol/K" },
    { name: "Cp", nameCn: "气相混合物摩尔比热容", unit: "J/mol/K" },
    { name: "MW", nameCn: "气相混合物分子量", unit: "g/mol" },
    { name: "MU", nameCn: "气相混合物粘度", unit: "Pa*s" },
    { name: "G", nameCn: "气相混合物摩尔吉布斯自由能", unit: "J/mol" },
    { name: "Z", nameCn: "气相混合物压缩因子", unit: null },
  ],
  liquid: [
    { name: "liquid_V", nameCn: "液相混合物摩尔体积", unit: "m³/mol" },
    { name: "liquid_H", nameCn: "液相混合物摩尔焓", unit: "J/mol" },
    { name: "liquid_S", nameCn: "液相混合物摩尔熵", unit: "J/mol/K" },
    { name: "liquid_Cp", nameCn: "液相混合物摩尔比热容", unit: "J/mol/K" },
    { name: "liquid_MW", nameCn: "液相混合物分子量", unit: "g/mol" },
    { name: "liquid_MU", nameCn: "液相混合物粘度", unit: "Pa*s" },
    { name: "liquid_G", nameCn: "液相混合物摩尔吉布斯自由能", unit: "J/mol" },
    { name: "liquid_Z", nameCn: "液相混合物压缩因子", unit: null },
  ]
}

const resultMap: any = [
  { name: "P", nameCn: "压力", unit: "Pa" },
  { name: "T", nameCn: "温度", unit: "K" },
  { name: "V", nameCn: "气相混合物摩尔体积", unit: "m³/mol" },
  { name: "phase_count", nameCn: "混合物相数", unit: null },
  { name: "liquid_V", nameCn: "液相混合物摩尔体积", unit: "m³/mol" },
  { name: "H", nameCn: "气相混合物摩尔焓", unit: "J/mol" },
  { name: "liquid_H", nameCn: "液相混合物摩尔焓", unit: "J/mol" },
  { name: "S", nameCn: "气相混合物摩尔熵", unit: "J/mol/K" },
  { name: "liquid_S", nameCn: "液相混合物摩尔熵", unit: "J/mol/K" },
  { name: "Cp", nameCn: "气相混合物摩尔比热容", unit: "J/mol/K" },
  { name: "liquid_Cp", nameCn: "液相混合物摩尔比热容", unit: "J/mol/K" },

  { name: "MW", nameCn: "气相混合物分子量", unit: "g/mol" },
  { name: "liquid_MW", nameCn: "液相混合物分子量", unit: "g/mol" },
  { name: "Z", nameCn: "气相混合物压缩因子", unit: null },
  { name: "liquid_Z", nameCn: "液相混合物压缩因子", unit: null },
  { name: "MU", nameCn: "气相混合物粘度", unit: "Pa*s" },
  { name: "liquid_MU", nameCn: "液相混合物粘度", unit: "Pa*s" },
  { name: "G", nameCn: "气相混合物摩尔吉布斯自由能", unit: "J/mol" },
  { name: "liquid_G", nameCn: "液相混合物摩尔吉布斯自由能", unit: "J/mol" },
];

const Component = (props: any) => {
  const [allData, setAllData] = useState<any>(null); //所有物质
  const history = useNavigate();
  const [materials, setMaterials] = useState<any>([]);
  const [cas_list, setCas_list] = useState<any>(null); //cas列表
  const [zs, setZs] = useState<any>(null); //摩尔分数
  const [T, setT] = useState<any>(25); //温度
  const [method, setMethod] = useState<any>("SRK"); //方法
  const [P, setP] = useState<any>(101325); //压力
  // const [npoints, setNpoints] = useState<any>(50); //扫描点数
  const [dataSource, setDataSource] = useState<any>(null); //计算结果
  // const [PTSource, setPTSource] = useState<any>(null); //包络线图数据
  // const [Tmin, setTmin] = useState<any>(25); //最低温度
  // const [Tmax, setTmax] = useState<any>(100); //最高温度
  const [propsLoading, setPropsLoading] = useState<any>(false); //物性数据加载中
  // const [chartsLoading, setChartsLoading] = useState<any>(false); //图像数据
  // const [isCalculate, setIsCalculat] = useState<any>(true); //组分数是否等于0

  useEffect(() => {
    getMaterials({}).then((r) => {
      setAllData(buidSource(buildOptionsData(r.data.response.data)));
    });
  }, []);

  const submit = (v: any) => {
    const zlist = v.zs.map((e: any) => Number(e));
    const mlist = materials.map((item: any) => item.cas_code);
    setZs(zlist);
    setCas_list(mlist);
    getResult(mlist, zlist);
  };

  const getResult = (l: any, z: any) => {
    setPropsLoading(true);
    calc_mixture_properties(l, z, T + K0, P, method).then((res) => {
      setDataSource(res.data.data);
      setPropsLoading(false);
    });
  };

  useEffect(() => {
    if (cas_list) {
      getResult(cas_list, zs);
    }
  }, [T, P]);

  console.log(dataSource);

  const getOneTotal = (arr: any) => {
    const v = Number((1 / arr.length).toFixed(4));
    let total = 0;
    const r: any = [];
    for (let n = 0; n < arr.length; n++) {
      let val = v;
      if (n === arr.length - 1) {
        val = Number((1 - total).toFixed(4));
      }
      r.push(val);
      total = total + val;
    }
    return r;
  };

  const buildOptionsData = (data: any) => {
    const o: any = [];
    if (!data.length) return o;
    data.map((item: any) => {
      o.push({
        id: item._id,
        label: `${item.Name_ZH} ${item.Molecular_formula}`,
        value: `${item.Name_ZH}${item.Molecular_formula}`,
        formula: `${item.Molecular_formula}`,
        alias: item.alias,
        description: item.description,
        type: item.Type,
        name: item.Name_ZH,
        ename: item.Name_EN,
        cas_code: item.cas,
        properties: "",
      });
    });
    return o;
  };

  const buidSource = (data: any) => {
    let s: any = {};
    data.forEach((item: any) => {
      if (s[item.type]) {
        s[item.type].push(item);
      } else {
        s[item.type] = [item];
      }
    });
    return s;
  };

  // console.log('source',source);
  // console.log('allData',allData);
  // console.log('materials',materials);

  const changeCheck = (e: any, item: any) => {
    const checked = e.target.checked;
    checked ? addMaterial(item) : delMaterial(item.id);
  };

  const addMaterial = (item: any) => {
    setMaterials([...materials, { ...item }]);
  };
  const delMaterial = (id: string) => {
    const n: any = [];
    materials.map((item: any) => {
      if (item.id !== id) {
        n.push(item);
      }
    });
    setMaterials(n);
  };

  console.log(materials);
  const showContent = (data: any) => {
    return (
      <Row>
        {data.map((item: any, index: any) => {
          return (
            <Col span={12} key={index}>
              <Space>
                <Checkbox
                  onChange={(e: any) => changeCheck(e, item)}
                  checked={materials?.some((m: any) => m.id === item.id)}
                >
                  {item.name}({rebuildFormula(item.formula)})
                </Checkbox>
              </Space>
            </Col>
          );
        })}
      </Row>
    );
  };

  const showReslut = () => {
    if (propsLoading) {
      return (
        <div className="loadingArea">
          <Spin />
        </div>
      );
    } else {
      return (
        <Row gutter={[20,20]}>
          <Col span={12}>
           <Card
          title={<div className="t3">气相：</div>}
          type="inner"
          // size="small"
          >
            <ul className="showMulresult"  style={{display:'block'}}>
              {rmap.gas.map((item:any,index:any)=>{
                return (
                  <li key={index}>
                    <div className="mtit">
                    {item.nameCn}：
                  </div>
                  <div className="mviv">
                    {dataSource[item.name]?dataSource[item.name]:'-'}
                    {dataSource[item.name]?<i>{item.unit}</i>:''}
                    
                  </div>
                  </li>
                )
              })}
            </ul>
            </Card>
          </Col>
          <Col span={12}>
          <Card
          title={<div className="t3">液相：</div>}
          type="inner"
          // size="small"
          >
          <ul className="showMulresult" style={{display:'block'}}>
              {rmap.liquid.map((item:any,index:any)=>{
                return (
                  <li key={index}>
                    <div className="mtit">
                    {item.nameCn}：
                  </div>
                  <div className="mviv">
                    {dataSource[item.name]?dataSource[item.name]:'-'}
                    {dataSource[item.name]?<i>{item.unit}</i>:''}
                  </div>
                  </li>
                )
              })}
            </ul>
            </Card>
          </Col>
        </Row>
      );
    }
  };

  //绑定快捷键设置温度
  const keySubUpdateT = (e: any) => {
    if (e.key === "Enter") {
      setT(Number(e.target.value));
    }
  };
  const keySubUpdateP = (e: any) => {
    if (e.key === "Enter") {
      setP(Number(e.target.value));
    }
  };

  return (
    <div className="mainPage">
      <div className="pTop2">
        {/* <div></div> */}
        <div className="homeLg">
          <img
            src={HomeLogo}
            alt=""
            style={{ cursor: "pointer", height: "23px", marginRight: "2rem" }}
            onClick={() => history("/")}
          />
        </div>
        <UserPanel />
      </div>
      <div className="mainContent">
        <div className="pageMainContent">
          <div className="p_right2" style={{ width: "40rem" }}>
            {allData
              ? Object.keys(allData).map((key: any) => {
                  return (
                    <Card
                      key={key}
                      title={<div className="t3">{key}</div>}
                      size="small"
                      type="inner"
                      className="mb1"
                    >
                      {showContent(allData[key])}
                    </Card>
                  );
                })
              : ""}
          </div>
          <div className="p_left" style={{ width: "calc(100% - 40rem)" }}>
            {materials.length ? (
              <Row>
                <Col span={24}>
                  <Card title={<div className="t3">设置混合物组分</div>} type="inner">
                    <Form
                      name="dynamic_form_nest_item"
                      onFinish={submit}
                      wrapperCol={{ span:8 }}
                      labelCol={{ span: 12 }}
                      autoComplete="off"
                    >
                      <Row>
                        {materials.map((item: any, index: any) => {
                          return (
                            <Col key={index} span={6}>
                              <Form.Item
                                name={["zs", index]}
                                label={`${item.name} (${item.cas_code})`}
                                style={{ margin: "0.2rem" }}
                                // rules={[{ required: true, message: 'Missing first name' }]}
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                          );
                        })}
                      </Row>
                      <div style={{ display: "flex" }}>
                        <Form.Item label={null} wrapperCol={{ span: 12 }}>
                          <Button type="primary" htmlType="submit">
                            Submit
                          </Button>
                        </Form.Item>
                      </div>
                    </Form>
                  </Card>
                </Col>
              </Row>
            ) : (
              <div className="t3">请选择物质！</div>
            )}
            {dataSource ? (
              <div className="mt2">
                <Space>
                  <div className="t2">物性计算结果：</div>
                  <Input
                    prefix="设置温度："
                    style={{ width: "15rem" }}
                    defaultValue={T}
                    onKeyDown={keySubUpdateT}
                    suffix={<span className="fieldUnit">℃</span>}
                  />
                  <Input
                    prefix="设置压力："
                    style={{ width: "20rem" }}
                    defaultValue={P}
                    onKeyDown={keySubUpdateP}
                    suffix={<span className="fieldUnit">Pa</span>}
                  />
                </Space>
                <Divider
                  style={{
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    margin: "1rem 0",
                    height: "1px",
                  }}
                />
                {showReslut()}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component;
